<!-- StockMovementDialog.vue -->
<template>
    <v-dialog
        v-model="visible"
        max-width="900"
        scrollable
        :attach="'#app'"
    >
      <v-card>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>
            Mouvements de stock – {{ product.reference }}
          </v-toolbar-title>
          <v-spacer/>
          <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
  
        <v-card-text class="pa-0">
          <v-data-table
              :headers="headers"
              :items="movements"
              :loading="loading"
              :items-per-page="10"
              dense
              class="elevation-0"
          >
            <!-- Δ en rouge ou vert -->
            <template v-slot:item.qtyChange="{ item }">
              <span :class="item.qtyChange < 0 ? 'red--text' : 'green--text'">
                {{ item.qtyChange }}
              </span>
            </template>
  
            <template v-slot:item.createdAt="{ item }">
              {{ new Date(item.createdAt).toLocaleString() }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import axios from 'axios';
  import store from '../store'

  export default {
    name: 'StockMovementDialog',
    props: {
      value:    { type: Boolean, default: false },   // v-model
      product:  { type: Object,  required: true }
    },
    data () {
      return {
        movements: [],
        loading: false,
        headers: [
          { text: 'Date',          value: 'createdAt' },
          { text: 'Raison',        value: 'reason'    },
          { text: 'Δ',             value: 'qtyChange' },
          { text: 'Stock après',   value: 'stockAfter'},
          { text: 'Commentaire',   value: 'comment'   }
        ]
      }
    },
    computed: {
      visible: {
        get () { return this.value },
        set (v) { this.$emit('input', v) }
      }
    },
    watch: {
      visible (open) {
        if (open) this.fetchMovements()
      }
    },
    methods: {
      async fetchMovements () {
        this.loading = true
        try {
          const { data } = await axios.get(`${store.getters.apiURL}/api/divers/stock-movements`, {
            params: { productReference: this.product.reference },
            headers: { "Authorization": 'Bearer ' + store.getters.getJwToken }
          })
          this.movements = data
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>
  